import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import cn from 'classnames';
import { Enum, isType, ColorPreset, getColorClass, responsiveClasses, useSpacingProps } from '../../../../library';
export var FontFamily = Enum({
  SERIF: 'serif',
  SANS: 'sans',
  MONO: 'mono',
  INHERIT: 'inherit'
});
export var TextAlignment = Enum({
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  JUSTIFY: 'justify'
});
export var Text = function Text(props) {
  var TagName = props.as;
  var _useSpacingProps = useSpacingProps(props),
    marginClasses = _useSpacingProps.marginClasses,
    paddingClasses = _useSpacingProps.paddingClasses;
  var classNames = cn(_defineProperty(_defineProperty(_defineProperty({}, "f--".concat(props.size), !!props.size), "t--".concat(props.family), props.family !== FontFamily.INHERIT), 't--uc', props.isUppercase), isType(ColorPreset, props.color) ? getColorClass(props.color) : '', props.align ? responsiveClasses('t--%s', props.align) : null, marginClasses, paddingClasses, props.className);
  var textStyles = isType(ColorPreset, props.color) ? props.style : _objectSpread({
    color: props.color
  }, props.style);
  return React.createElement(TagName, {
    className: classNames,
    style: textStyles,
    children: !!props.text ? props.text : props.children
  });
};
Text.defaultProps = {
  family: FontFamily.INHERIT,
  as: 'div',
  size: 'inherit'
};